export default "__VITE_ASSET__dd20c11c__"